import { ChangeDetectionStrategy, Component, inject, output } from '@angular/core';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';
import { PlatformService } from '@ld.consumer-portal/utils';

import { LOANDEPOT_SUPPORT_DISPLAY, LOANDEPOT_SUPPORT_TEL } from '@ld.consumer-portal/constants';
import { LanguageToggleComponent } from '@ld.consumer-portal/i18n';

@Component({
  selector: 'ld-public-header',
  imports: [LanguageToggleComponent, TranslocoDirective],
  templateUrl: './public-header.component.html',
  styleUrls: ['./public-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicHeaderComponent {
  readonly logo = '/assets/images/loandepot-logo-3d-dark-metallic.svg';

  private readonly transloco = inject(TranslocoService);
  private readonly platformService = inject(PlatformService);

  protected readonly isNativeMobile = this.platformService.isNativeMobile;

  readonly navigationItems = [
    { label: this.transloco.translate('publicHeaderNavProducts'), href: '#' },
    { label: this.transloco.translate('publicHeaderNavFindExpert'), href: '#' },
    { label: this.transloco.translate('publicHeaderNavHomeSearch'), href: '#' },
    { label: this.transloco.translate('publicHeaderNavLearningCenter'), href: '#' },
  ];

  readonly phoneNumber = LOANDEPOT_SUPPORT_DISPLAY;
  readonly phoneHref = LOANDEPOT_SUPPORT_TEL;

  signIn = output<void>();

  onApplyNow() {
    // Handle Apply Now action
  }

  onSignIn(): void {
    this.signIn.emit();
  }
}
